/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mMenu.vue?vue&type=template&id=8ffebd16&scoped=true"
import script from "./mMenu.vue?vue&type=script&lang=js"
export * from "./mMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffebd16",
  null
  
)

export default component.exports